var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFastCasual(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avatar/location/fast casual") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.598 L0,19.001 L14,19.001 L14,1.598 C11.82,0.494 9.795,0.001 6.999,0.001 C4.273,0.001 2.544,0.456 0,1.598 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0.001 0 25 4 25 6 5 8 5 9.898 25 14 25 14 0.001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.1415,0.0004 C0.0585,0.3214 -0.0005,0.6524 -0.0005,1.0004 C-0.0005,3.2104 1.7895,5.0004 3.9995,5.0004 C6.2095,5.0004 7.9995,3.2104 7.9995,1.0004 C7.9995,0.6524 7.9415,0.3214 7.8585,0.0004 L0.1415,0.0004 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,7 L7.411,9.88 L0.24,11.001 C0.24,12.106 1.134,13.003 2.24,13.007 L9.743,13.021 C11.23,13.021 11.894,11.641 11.329,10.237 C11.329,10.237 9.522,5.217 8.863,3.727 C8.297,2.45 7.39,1.37 6,0.598 L6,7 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5512,8.1498 C6.7612,8.1498 8.5512,6.3598 8.5512,4.1498 C8.5512,1.9398 6.7612,0.1498 4.5512,0.1498 C2.3412,0.1498 0.5512,1.9398 0.5512,4.1498 C0.5512,6.3598 2.3412,8.1498 4.5512,8.1498",
    id: "path-9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avatar/location/fast-casual",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(18.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Clip-7",
    fill: "#DEDFE1",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9999,16.7201 C8.2679,17.4381 2.5989,22.6341 -0.0001,28.2231 L-0.0001,14.0001 L4.9999,16.0001 L7.7589,14.0001 L13.9999,14.0001 L13.9999,16.7201 Z",
    id: "Fill-9",
    fill: "#BEC0C2",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#FEFEFE",
    mask: "url(#mask-2)",
    points: "11.9999 0.0004 8.5009 3.4994 6.9999 2.0004 5.4669 3.4674 1.9999 0.0004 6.9999 -4.9996"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#BD8855",
    mask: "url(#mask-2)",
    points: "8.9999 0.0004 6.9999 2.0004 4.9999 0.0004 6.9999 -1.9996"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.9999,21.0004 C27.2099,21.0004 28.9999,19.2104 28.9999,17.0004 C28.9999,14.7904 27.2099,13.0004 24.9999,13.0004 C22.7899,13.0004 20.9999,14.7904 20.9999,17.0004 C20.9999,19.2104 22.7899,21.0004 24.9999,21.0004",
    id: "Fill-13",
    fill: "#B34B85"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(18.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Clip-20",
    fill: "#B34B85",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9999,-2.2799 C8.2679,-1.5619 2.5989,3.6341 -0.0001,9.2231 L-0.0001,-4.9999 L13.9999,-4.9999 L13.9999,-2.2799 Z M11.9999,3.0004 L11.9999,25.0004 L-3.0001,25.0004 L-3.0001,18.0004 L11.9999,3.0004 Z",
    id: "Combined-Shape",
    fill: "#852E64",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-28",
    transform: "translate(21.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#BD8855",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8451,0.0004 C5.4441,2.2264 2.6531,3.8304 0.5181,3.8304 C-1.6179,3.8304 -1.4589,2.2264 0.1121,0.0004 L7.8451,0.0004 Z",
    fill: "#926E30",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(26.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Clip-34",
    fill: "#BD8855",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-33",
    fill: "#FEFEFE",
    mask: "url(#mask-8)",
    points: "5.9999 6.0004 9.5009 4.4994 8.4329 0.8924 5.4149 -0.1246"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-36",
    fillOpacity: 0.25,
    fill: "#010202",
    mask: "url(#mask-8)",
    points: "5.9999 0.5981 8.5309 9.6531 7.4109 9.8801 5.9999 7.0001"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-40",
    fill: "#303035",
    points: "28.9999 38.0004 23.9999 38.0004 25.9999 31.0004 30.9999 31.0004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9999,24.5981 C16.6079,25.2991 15.9999,26.4381 15.9999,28.2421 L15.9999,30.0001 L19.9999,30.0001 L19.9999,27.4691 C19.9999,26.2271 18.9999,25.0111 17.9999,24.5981",
    id: "Fill-42",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999,30.0004 L15.9999,38.0004 C15.9999,39.1044 16.8959,40.0004 17.9999,40.0004 L24.9999,40.0004 C26.1039,40.0004 26.9999,39.1044 26.9999,38.0004 L19.9999,37.0004 L19.9999,30.0004 L15.9999,30.0004 Z",
    id: "Fill-44",
    fill: "#BD8855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3065,34.7777 L62.7005,34.2987 L64.7835,49.1047 C65.1695,51.6467 63.9435,53.0007 61.9195,53.0007 L49.9995,53.0007 C49.1165,53.0007 49.8265,54.5797 49.5725,55.4247 L49.4275,65.5747 C49.1735,66.4207 48.3945,67.0007 47.5125,67.0007 L45.9995,67.0007 L45.6765,51.4187 C45.8675,50.0787 46.9315,47.0337 48.2735,46.8657 L56.8505,46.1497 L57.3015,38.2357 C57.4225,36.5827 58.5155,35.1167 60.3065,34.7777",
    id: "Fill-58",
    fill: "#E06E9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8427,48.3393 L54.9997,53.0003 L47.6757,53.0063 L49.5907,48.8693 L60.8427,48.3393 Z M59.5512,35.0043 L58.0002,46.0003 L56.8502,46.1503 C56.8502,46.1503 57.2512,39.1023 57.3432,37.8453 C57.4212,36.7813 58.1072,35.3503 59.5512,35.0043 Z",
    id: "Combined-Shape",
    fill: "#B34B85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9999,39.0004 L62.9999,39.0004 L61.3219,47.3924 C61.1349,48.3274 60.3139,49.0004 59.3599,49.0004 L49.9999,49.0004 L49.9999,46.6774 L57.9999,46.0004 L58.9999,39.0004 Z",
    id: "Fill-63",
    fill: "#775823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9999,41.0004 L14.9519,51.2214 C15.0639,52.2334 15.9209,53.0004 16.9399,53.0004 L25.9999,53.0004 C27.1039,53.0004 27.9999,53.8964 27.9999,55.0004 L27.9999,67.0004 L25.1499,67.0004 L24.1499,57.0004 L15.1499,57.0004 L13.1499,67.0004 L10.9999,67.0004 L10.9999,39.0004 L12.1499,39.0004 C13.2539,39.0004 13.9999,39.8964 13.9999,41.0004 Z M64.8319,50.4414 L65.9999,41.0004 C65.9999,39.8964 66.7459,39.0004 67.8509,39.0004 L68.9999,39.0004 L68.9999,67.0004 L66.8509,67.0004 L64.8509,57.0004 L55.8509,57.0004 L54.8509,67.0004 L51.9999,67.0004 L51.9999,55.0004 C51.9999,53.8964 52.8959,53.0004 53.9999,53.0004 C58.2990333,53.0004 60.9657,53.0004 61.9999,53.0004 C63.5512,53.0004 64.7189,51.4544 64.8319,50.4414 Z M30,67 L30,45 L50,45 L50,67 L30,67 Z",
    id: "Combined-Shape",
    fill: "#DEDFE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9999,41.4584 C43.9999,43.4144 42.4149,45.0004 40.4579,45.0004 C38.5019,45.0004 36.9169,43.4144 36.9169,41.4584 L43.9999,41.4584 Z",
    id: "Fill-67",
    fill: "#DEDFE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9999,39.0004 C61.4419,39.3124 59.7859,40.0584 58.6789,41.1864 L58.9999,39.0004 L62.9999,39.0004 Z",
    id: "Fill-69",
    fill: "#63491C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8685,16.016 C28.4775,17.16 27.1365,17.984 24.9985,17.984 C22.8615,17.984 21.5695,17.16 21.1295,16.016 L28.8685,16.016 Z",
    id: "Fill-70",
    fill: "#E06E9D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(55.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-55",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#775823",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8685,-0.0709 C2.8995,2.4321 4.5925,5.5241 7.5375,7.2911 L10.5185,0.5551 L1.8685,-0.0709 Z",
    fill: "#010202",
    mask: "url(#mask-10)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.9999,6.0004 C5.9999,5.4474 5.5519,5.0004 4.9999,5.0004 C4.4479,5.0004 3.9999,5.4474 3.9999,6.0004 C3.9999,6.5524 4.4479,7.0004 4.9999,7.0004 C5.5519,7.0004 5.9999,6.5524 5.9999,6.0004",
    id: "Fill-71",
    fill: "#775823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9999,2.0004 C9.9999,3.1044 9.1039,4.0004 7.9999,4.0004 C6.8959,4.0004 5.9999,3.1044 5.9999,2.0004 C5.9999,0.8964 6.8959,0.0004 7.9999,0.0004 C9.1039,0.0004 9.9999,0.8964 9.9999,2.0004",
    id: "Fill-72",
    fill: "#010202"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastCasual);
export default __webpack_public_path__ + "static/media/fast-casual.a62024e46a2dac797bbc099272211100.svg";
export { ForwardRef as ReactComponent };